import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ColumnAlignment } from '@mews/b2b-ui';
import EntityTable from '../../../entityManagement/components/EntityTable';
import { EntityDeleteButton } from '../../../entityManagement/components/EntityDeleteButton';
import { getFloorIds } from '../../selectors/floors';
import FloorEditLink from './FloorEditLink';

const mapping = [
    {
        valueKey: 'name',
        title: <LocalizedText textKey={TextKey.FloorPlural} />,
        render: (id: $TSFixMe, { scope }: $TSFixMe) => <FloorEditLink id={id} scope={scope} />,
    },
    {
        title: <LocalizedText textKey={TextKey.ActionPlural} />,
        valueKey: 'action',
        render: (id: $TSFixMe, { scope }: $TSFixMe) => <EntityDeleteButton id={id} scope={scope} />,
        columnAlignment: ColumnAlignment.Right,
    },
];

const FloorsTable = EntityTable({ mapping });

export default connect(
    createStructuredSelector({
        source: getFloorIds,
    })
)(FloorsTable);
